export default __webpack_public_path__ + "static/media/2018-desktop.27efcd37.jpg";